import React from 'react';
import FontAwesome from 'react-fontawesome';
import { NavLink } from 'react-router-dom';
import { getWorkHourFromTotalMinutes } from '../../../../utils/work';
import PersonPhoto from '../../../common/card/personPhoto';
// import dlv from 'dlv'
// import moment from 'moment'

const ReportTaskCard = ({data={}, filter={}, linkPrefix='/report/task', style={workVisible: ['wait', 'active', 'finish', 'pause', 'delete', 'jv', 'time']}}) => {

  const { _id: taskId, name, taskName, personList=[] } = data;

  const { staffTotal, taskTotal, jvTotal, jvRemark, taskWait, taskActive, taskPause, taskFinish, taskOverdue, taskDelete } = data
  const { timeTotal } = data
  const { numberTotal, numberIsDecimal=false } = data

  const numberAVG = (numberTotal && taskFinish>1) ? ( numberIsDecimal ? (numberTotal/taskFinish).toFixed(2) : Math.round(numberTotal/taskFinish) ) : undefined

  const workTime = getWorkHourFromTotalMinutes(timeTotal)


  const statusColor = (taskTotal || taskFinish) ? 'dark' : 'secondary'

  return ( 
    <React.Fragment>
      <div className="card mb-2 text-dark p-0">
        <div className="card-body p-2">
        <NavLink className="stretched-link" to={`${linkPrefix}/${taskId}/?filter=${filter.filter}&date=${filter.date}`} ></NavLink>
        <div className="row no-gutters align-items-center justify-content-end">
          <div className="col-auto ml-3 pt-1 mr-auto">
            <h4 className={`text-${statusColor}`}><FontAwesome name='file-code-o' /> {name || taskName}</h4>
            {personList.length>0 && <React.Fragment>
            <div className="col-auto p-0">
              <div className="row no-gutters">
                 {personList.filter((_,index)=> index<10).map((item,index) => {
                   return (<div key={index} className='col-auto text-center'>
                     <PersonPhoto id={item} size={40} className='rounded-circle' />
                   </div>)
                 })}

                  {personList.length>10 && <div className="col-auto">
                    <h4 className="d-inline"><span className="badge badge-pill badge-success">+{personList.length-10}</span></h4>
                  </div>}
              </div>
            </div>
          </React.Fragment>}
          </div>
          
          {(taskTotal || taskFinish) && <div className="col-auto mr-2">
            <div className="row no-gutters justify-content-center align-items-center">
                {numberTotal!==undefined && <div className='col-auto mx-2 text-center'>
                  <h4><span className="badge badge-pill badge-primary">{numberTotal.toLocaleString()}</span></h4>
                  Total
                </div>}
                {numberAVG!==undefined && <div className='col-auto mx-2 text-center'>
                  <h4><span className="badge badge-pill badge-primary">{numberAVG.toLocaleString()}</span></h4>
                  AVG
                </div>}
                {style.workVisible.includes('jv') && jvTotal>0 && <div className='col-auto mr-3 text-center'>
                <h5><span className="text-primary">
                    {jvRemark && <span className="text-danger">*</span>}
                    {jvTotal.toLocaleString()}&#3647;</span></h5>
                    Job Value
                </div>}
                {style.workVisible.includes('time') && <div className='col-auto mr-3 text-center'>
                <h5>
                  <span className="text-primary"><FontAwesome name="clock-o" /> {workTime}</span>
                </h5>
                Work Time
                </div>}
                <div className='col-auto mx-3 text-center'>
                  <h4><span className="badge badge-pill badge-primary">{staffTotal}</span></h4>
                  Staff
                </div>

                {style.workVisible.includes('wait') && <div className='col-auto mx-1 text-center'>
                <h4><span className="badge badge-pill badge-info">{taskWait}</span></h4>
                Plan
                </div>}
                {style.workVisible.includes('active') && <div className='col-auto mx-1 text-center'>
                <h4><span className="badge badge-pill badge-warning">{taskActive}</span></h4>
                Active
                </div>}
                {style.workVisible.includes('finish') && <div className='col-auto mx-1 text-center'>
                <h4><span className="badge badge-pill badge-success">{taskFinish}</span></h4>
                Finish
                </div>}
                {style.workVisible.includes('pause') && <div className='col-auto mx-1 text-center'>
                <h4><span className="badge badge-pill badge-secondary">{taskPause}</span></h4>
                Pause
                </div>}
                {style.workVisible.includes('overdue') && <div className='col-auto mx-1 text-center'>
                <h4><span className="badge badge-pill badge-secondary">{taskOverdue}</span></h4>
                Overdue
                </div>}
                {style.workVisible.includes('delete') && <div className='col-auto mx-1 text-center'>
                <h4><span className="badge badge-pill badge-secondary">{taskDelete}</span></h4>
                Delete
                </div>}
                
            </div>
          </div>}
          {!taskTotal && !taskFinish && <h5 className="text-secondary mr-4">ไม่มีข้อมูลปฏิบัติงาน / No Task</h5>}
        </div>
        </div>
      </div>
    </React.Fragment>
    );
    
}
 
export default ReportTaskCard;